module.exports = __webpack_public_path__ + "static/media/youareafailure.d1a17e40.png";